import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Form, Input, DatePicker, Col, Row, Card, Button, Select, Checkbox } from 'antd';
import { DownOutlined, UpOutlined, } from '@ant-design/icons';
import dayjs from 'dayjs'
const { RangePicker } = DatePicker;
const submit_button = 'data:image/png;base64,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'
// const [filter_data, set_filter_data] = useState([
//     {
//         type: 'text',
//         label: '任務名稱',
//         name: 'taskname'
//     },
//     {
//         type: 'datepicker',
//         label: '指派日期',
//         name: 'date'
//     },
//     {
//         type:'checkbox-group',
//         label:'模福搜尋',
//         name:'category',
//         options:[
//             {
//                 label:'上課花絮',
//                 value:1,
//                 id:1
//             },
//             {
//                 label:'下課花絮',
//                 value:2,
//                 id:2
//             },
//             {
//                 label:'上課情況',
//                 value:3,
//                 id:3
//             },
//             {
//                 label:'克課花絮',
//                 value:4,
//                 id:4
//             },
//             {
//                 label:'4上課花絮',
//                 value:5,
//                 id:5
//             }
//         ]
//     },
//     {
//         type:'checkbox-group',
//         label:'模福搜尋2',
//         name:'category2',
//         options:[
//             {
//                 label:'上課花絮',
//                 value:1,
//                 id:1
//             },
//             {
//                 label:'下課花絮',
//                 value:2,
//                 id:2
//             },
//             {
//                 label:'上課情況',
//                 value:3,
//                 id:3
//             },
//             {
//                 label:'克課花絮',
//                 value:4,
//                 id:4
//             },
//             {
//                 label:'4上課花絮',
//                 value:5,
//                 id:5
//             }
//         ]
//     }
// ])
// const handleSubmit = (values) => {

//     let search_tmp = {};
//     if (values.length != 0 && values.date != null && values.date[0] != '' && values.date[1] != '' && values != 'undefined' && values != '') {
//         search_tmp['start_date'] = values.date[0];
//         search_tmp['end_date'] = values.date[1];
//     }
//     if (values.category2 != '' && values.category2 != null && values.category2 != undefined) {
//         search_tmp['category2'] = values.category2;
//     }
//     if (values.category != '' && values.category != null && values.category != undefined) {
//         search_tmp['category'] = values.category;
//     }
//     if (values.taskname != '' && values.taskname != null && values.taskname != undefined) {
//         search_tmp['taskname'] = values.taskname;
//     }
//     console.log(search_tmp)
// };
// const [title, setTitle] = useState('任務學習成績查詢')
//  <SearchModal data={filter_data} title={title} TaskName={'請輸入欲查詢生字'} onSubmit={handleSubmit}  Bodycolor={'green'} Headcolor={'red'} LabelColor={'blue'} row_size={1}/>

const SearchModal = ({
    data,
    onSubmit,
    set_date,
    date,
    title,
    TaskName,
    BodyColor = 'green',
    HeadColor = 'red',
    SubmitColor = '#000',
    SubmitTitle = null,
    LabelColor = 'blue',
    row_size = 1,
    BorderStyle = '2px solid #000000',
    collapse = false
}) => {
    const [form] = Form.useForm()
    const [open, setOpen] = useState(true)
    const [order_data, set_order_data] = useState([])
    const [controll, setControll] = useState([]);
    // initialize controll array on component mount
    useEffect(() => {
        const initControll = data.map((item, index) => ({
            key: index,
            open: true,
        }));
        setControll(initControll);
    }, [data]);
    const onFinish = (values) => {
        let time = []
        if (values.date && Array.isArray(values.date)) {
            // RangePicker
            values.date.forEach((item, index) => {
                time.push(item.format('YYYY-MM-DD'));
            });
        } else if (values.date && typeof values.date === 'object') {
            // DatePicker
            time.push(values.date.format('YYYY-MM-DD'));
        }

        if (values.date !== '' && values.date !== null && values.date !== undefined) {
            values.date = time;
        }
        console.log(values)
        onSubmit(values);
    };

    const onFormChange = (changedFields, allFields) => {
        console.log(allFields)
        let values = allFields.reduce((obj, field) => {
            obj[field.name[0]] = field.value;
            return obj;
        }, {});
        let time = [];

        if (values.date && Array.isArray(values.date)) {
            // RangePicker
            values.date.forEach((item, index) => {
                time.push(item.format('YYYY-MM-DD'));
            });
        } else if (values.date && typeof values.date === 'object') {
            // DatePicker
            time.push(values.date.format('YYYY-MM-DD'));
        }

        if (values.date !== '' && values.date !== null && values.date !== undefined) {
            values.date = time;
        }
        onSubmit(values);
    };

    useEffect(() => {
        const checkboxGroups = data.filter(item => item.type === 'checkbox-group');
        const nonCheckboxGroups = data.filter(item => item.type !== 'checkbox-group');

        const newFilterData = [...nonCheckboxGroups, ...checkboxGroups];
        set_order_data(newFilterData);
    }, [data])
    const hide = (index) => {
        let data_tmp = JSON.parse(JSON.stringify(controll));
        data_tmp[index]['open'] = false
        setControll(data_tmp)
    }
    const show = (index) => {
        let data_tmp = JSON.parse(JSON.stringify(controll));
        data_tmp[index]['open'] = true
        setControll(data_tmp)
    }
    const renderFormItem = (item) => {
        switch (item.type) {
            case 'text':
                return (
                    <Input className='col-auto' placeholder={TaskName} style={{ border: BorderStyle }} />
                );
            case 'rangepicker':
                return (
                    <RangePicker
                        className='col-auto'
                        style={{ border: BorderStyle, textAlign: 'center' }}
                    />
                );
            case 'datepicker':
                return (
                    <DatePicker
                        className='col-auto'
                        style={{ border: BorderStyle, textAlign: 'center' }}
                    />
                );
            case 'select':
                return (
                    <Select className='col-auto' style={{ border: BorderStyle }} />
                )
            case 'checkbox-group':
                return (
                    // <Box>
                    <Checkbox.Group className='col-12' style={{ fontSize: '1.2em', margin: '8px' }}>
                        <Row gutter={24}>
                            {item.options.map((option, optionIndex) => (
                                // <Col span={5} key={optionIndex} >
                                <div className='col-3'>
                                    <Checkbox value={option.value}><span style={{ display: 'inline' }}>{item.options[optionIndex].label}</span></Checkbox>
                                </div>
                                // </Col>
                            ))}
                        </Row>
                    </Checkbox.Group>
                    // </Box>
                )

            default:
                return null;
        }
    };

    return (
        <Form
            form={form}
            onFinish={onFinish}
            onFieldsChange={onFormChange}
            name="basic"
            labelCol={{
            }}
            wrapperCol={{
                span: 16,
            }}

            initialValues={{
                remember: true,
            }}
            autoComplete="off"
            colon={false}
        >
            <Card
                title={title && <span>{title}</span>}
                headStyle={{
                    backgroundColor: '#316798',
                    color: 'white', // text color
                    fontFamily: 'Source Sans Pro',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    fontSize: '36px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    letterSpacing: '0.33em',
                }}
                bodyStyle={{
                    // padding: '10px',
                    fontFamily: 'Source Sans Pro',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    fontSize: '36px',
                    // lineHeight: '45px',
                    letterSpacing: '0.2em',
                    boxShadow: !(BodyColor) && '0px 0px 10px rgba(0, 0, 0, 0.25)',
                    backgroundColor: BodyColor ? BodyColor : '#EEF2F6',
                    borderRadius: '10px',
                    // minHeight: '140px',
                }}
            >
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        // height: '110px',
                        fontSize: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Row gutter={[24, 24]}>
                            {order_data.map((item, index) => (<>
                                {row_size == 1 || item.type == 'checkbox-group' ?
                                    <>

                                        <Col span={24}>
                                            <Form.Item
                                                label={
                                                    <label className="col-4" style={{ fontWeight: 600, color: '#e33d98' }}>
                                                        {item.label}
                                                        {item.type === 'checkbox-group' &&
                                                            (controll[index].open ? (
                                                                <DownOutlined onClick={() => hide(index)} />
                                                            ) : (
                                                                <UpOutlined onClick={() => show(index)} />
                                                            ))}
                                                    </label>
                                                }
                                                name={item.name}
                                            >
                                                {controll[index].open && renderFormItem(item)}
                                            </Form.Item>
                                            <span>&nbsp;&nbsp;</span>
                                        </Col>

                                    </>
                                    :
                                    <>
                                        {row_size == 2 && item.type != 'checkbox-group' ?
                                            <>
                                                <Col span={12}>
                                                    <Form.Item
                                                        label={
                                                            <label className="col-2" style={{ fontWeight: 600, color: '#e33d98' }}>
                                                                {item.label}
                                                                {item.type === 'checkbox-group' &&
                                                                    (controll[index].open ? (
                                                                        <DownOutlined onClick={() => hide(index)} />
                                                                    ) : (
                                                                        <UpOutlined onClick={() => show(index)} />
                                                                    ))}
                                                            </label>
                                                        }
                                                        name={item.name}
                                                    >
                                                        {controll[index].open && renderFormItem(item)}
                                                    </Form.Item>
                                                    <span>&nbsp;&nbsp;</span>
                                                </Col>
                                            </>
                                            :
                                            <>
                                                {row_size == 3 && item.type != 'checkbox-group' ?
                                                    <>
                                                        <Col span={8}>
                                                            <Form.Item
                                                                label={
                                                                    <label className="col-auto" style={{ fontWeight: 600, color: '#e33d98' }}>
                                                                        {item.label}
                                                                        {item.type === 'checkbox-group' &&
                                                                            (controll[index].open ? (
                                                                                <DownOutlined onClick={() => hide(index)} />
                                                                            ) : (
                                                                                <UpOutlined onClick={() => show(index)} />
                                                                            ))}
                                                                    </label>
                                                                }
                                                                name={item.name}
                                                            >
                                                                {controll[index].open && renderFormItem(item)}
                                                            </Form.Item>
                                                            <span>&nbsp;&nbsp;</span>
                                                        </Col>
                                                    </>
                                                    :
                                                    <>
                                                        <div className='col-2 '>
                                                            {/* <Col span={24}> */}
                                                            {controll[index].open ?
                                                                <>
                                                                    <Form.Item label={<label className='col-auto' style={{ fontWeight: 600, color: '#e33d98' }}>{item.label}
                                                                        {item.type == 'checkbox-group' && collapse ?
                                                                            <>
                                                                                {controll[index].open ? <DownOutlined onClick={e => hide(index)} /> : <UpOutlined onClick={e => show(index)} />}
                                                                            </>
                                                                            :
                                                                            <>
                                                                            </>
                                                                        }
                                                                    </label>} name={item.name}>
                                                                        {renderFormItem(item)}
                                                                    </Form.Item>
                                                                </>
                                                                :
                                                                <>
                                                                </>
                                                            }
                                                            {/* </Col> */}
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </>))}
                        </Row>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', textAlign: 'right' }}>
                    <Form.Item>
                        {SubmitTitle && (<>
                            <Button htmlType='submit' type={'primary'}>
                                {SubmitTitle}
                            </Button>
                        </>)}
                        {SubmitTitle == null && (<>
                            <Button htmlType='submit' type={'text'} style={{
                                color: 'transparent', width: '150px', height: '40px',
                                background: `url${submit_button})`
                            }}
                            >{SubmitTitle}</Button>
                        </>)}
                    </Form.Item>
                </div>
            </Card>
        </Form>
    );
}

export default SearchModal;

const renderFormItem = (item) => {
    switch (item.type) {
        case 'text':
            return (
                <Input className='col-auto' placeholder={item.placeholder} style={{ border: '2px solid #000000' }} />
            );
        case 'datepicker':
            return (
                <RangePicker
                    className='col-auto'
                    style={{ border: '2px solid #000000', textAlign: 'center' }}
                />
            );
        case 'select':
            return (
                <Select className='col-auto' style={{ border: '2px solid #000000' }} />
            )
        case 'checkbox-group':
            return (
                // <Box>
                <Checkbox.Group className='col-auto' style={{ fontSize: '1.2em', margin: '8px' }} options={item.options} />
                // </Box>
            )

        default:
            return null;
    }
};